import axios from 'axios'

const wordpress = axios.create({
  baseURL: process.env.baseUrlWordpress,
  withCredentials: false,
  timeout: 30000
})

export default wordpress
